import React from 'react'
import styled from 'styled-components'
import { useTranslations } from 'next-intl'

const Wrapper = styled.label`
  position: relative;
  display: inline-block;
  width: 147px;
  height: 54px;
  opacity: ${props => (props.disabled ? 0.4 : 1)};
  cursor: ${props => (props.disabled ? 'default' : 'pointer')};
`

const Checkbox = styled.input.attrs({
  type: 'checkbox'
})`
  display: none;
`
const Slider = styled.span`
  display: flex;
  z-index: 0;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  transition: 0.4s;
  background-color: ${props => props.theme.colors.text.inputLightBackground};
  border-radius: 27px;
  &:before {
    position: absolute;
    content: '';
    left: 4px;
    bottom: 4px;
    height: 46px;
    width: 72px;
    background-color: white;
    border-radius: 27px;
    transition: 0.4s;
    ${Checkbox}:checked + & {
      transform: translateX(67px);
    }
  }
`
const ToggleFirst = styled.div`
  z-index: 1;
  font-family: ${props => props.theme.fonts.avenirNextMedium};
  color: ${props =>
    props.switchStatus
      ? props.theme.colors.primary
      : props.theme.colors.text.input};
  padding: 0 2.9rem 0 0;
  font-size: 1rem;
`
const ToggleSecond = styled.div`
  z-index: 1;
  font-family: ${props => props.theme.fonts.avenirNextMedium};
  color: ${props =>
    props.switchStatus
      ? props.theme.colors.text.input
      : props.theme.colors.primary};
  font-size: 1rem;
`

const ToggleSwitch = ({
  handleSwitch,
  switchStatus = false,
  enabledText: propEnabledText,
  disabledText: propDisabledText,
  disabled = false
}) => {
  const translate = useTranslations('ui.switch')
  const enabledText = propEnabledText || translate('enabled')
  const disabledText = propDisabledText || translate('disabled')
  

  return (
    <Wrapper disabled={disabled}>
      <Checkbox
        onChange={disabled ? () => {} : handleSwitch}
        checked={!switchStatus}
      />
      <Slider>
        <ToggleFirst switchStatus={switchStatus}>{enabledText}</ToggleFirst>
        <ToggleSecond switchStatus={switchStatus}>{disabledText}</ToggleSecond>
      </Slider>
    </Wrapper>
  )
}



export default ToggleSwitch
